import React, { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "next-i18next";
import styles from "./eco-switch.module.scss";
import { TemplateText } from "../../atoms";

export const EcoSwitch = (props: any) => {
  const { onChange, status } = props;
  const { t } = useTranslation();
  const [eco, setEco] = useState(status);

  const handleChange = (val: any) => {
    if (val !== eco) {
      setEco(val);
      onChange(val);
    }
  };

  return (
    <div className={styles.root}>
      <button
        className={classNames(styles.option, { [styles.selected]: !eco })}
        onClick={() => handleChange(false)}
        type="button"
      >
        <TemplateText template="small">{t("EcoSwitch.todos")}</TemplateText>
      </button>
      <button
        className={classNames(styles.option, { [styles.selected]: eco })}
        onClick={() => handleChange(true)}
        type="button"
      >
        <TemplateText template="small">{t("EcoSwitch.eco")}</TemplateText>
      </button>
    </div>
  );
};
